import PartSelectionTab from "./PartSelectionTab";
import partTabsJson from "../data/selections/partDefinition.json";

const partTabs = (selectedState, json) => {
  const activeFieldId = selectedState.fieldId
  const activeAreaId = selectedState.areaId
  // 「全分野」を選択時
  if (activeFieldId.toString() === "00" && activeAreaId === "D0") {
    return json.tabs
  // 「全分野」以外の分野を選択時
  } else {
    // 時系列比較を除いた章を抽出
    return json.tabs.filter((e) => e.id !== "P05")
  }
}

function PartSelectionsArea({ selectedState, onSelect = f => f }) {
  const tabs = partTabs(selectedState, partTabsJson)
  const classNames = `
    grid gap-x-0.5
    mt-4 sm:mt-6 md:mt-8
    border-main-blue border-solid border-0 border-b-4
  `
  const gridCols = tabs.length === 4 ? " grid-cols-4" : " grid-cols-5"
  return (
    <div className={classNames.concat(gridCols)}>
      {
        tabs.map((tab) => {
          return <PartSelectionTab
            tab={tab}
            isActive={ selectedState.partId === tab.id}
            onSelect={onSelect}
            key={tab.name.toString()}
          />
        })
      }
    </div>
  );
}

export default PartSelectionsArea;
